<!--
 * @Description: 
 * @Author: yuxin
 * @Date: 2025-05-29 18:21:10
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-05-30 15:58:56
 * @FilePath: \mgr_web\src\views\group\sop\viewChatHistory.vue
-->
<template>
  <el-dialog
    :title="row.groupChatName"
    @close="closeDialog"
    :visible.sync="dialogVisibleM"
    :modal-append-to-body="true"
    width="50%"
    class="add-label-dialog"
    :close-on-click-modal="false"
    :center="true"
    :close-on-press-escape="true"
  >
    <!-- {{ row }} -->
   <!-- <div style="height:570px"> -->
     <GroupChatDia v-if="newEditionDialogVisible" :idData="groupChatId" />
   <!-- </div> -->

    <!-- <div
      slot="footer"
      class="dialog-footer"
      style="display: flex;justify-content: flex-end;margin-top: 10px;"
    >
      <el-button size="small " @click="closeDialog" style="margin-right:20px"
        >关 闭</el-button
      >
    </div> -->
  </el-dialog>
</template>
<script>
import GroupChatDia from "@/views/group/components/newGroupChat/groupChatDia.vue";
export default {
  name: "viewChatHistory",
  components: {
    GroupChatDia,
  },
  props: {
    dialogVisibleV: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      // 控制
      newEditionDialogVisible: false,
      groupChatId: null,
    };
  },

  watch: {
    dialogVisibleV: {
      handler(newVal, oldVal) {
        console.log("监听 dialogVisibleV", newVal);
        this.dialogVisibleM = newVal;
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    /**关闭 */
    closeDialog(reset) {
      this.$emit("update:dialogVisibleV", false);
      // 把新版聊天组件弹窗销毁
      this.newEditionDialogVisible = false;
    },
  },
  created() {
    this.newEditionDialogVisible = true;
    this.groupChatId = this.row.groupChatId;
  },
};
</script>
<style lang="scss" scoped></style>
